// extracted by mini-css-extract-plugin
export var colorSquare = "_uo-0";
export var danger = "_uo-5";
export var lightPink = "_uo-8";
export var neutralBlue = "_uo-7";
export var neutralYellow = "_uo-6";
export var normal = "_uo-1";
export var primary = "_uo-2";
export var primaryLight = "_uo-3";
export var solidBlack = "_uo-g";
export var solidGreen = "_uo-b";
export var solidLightBlue = "_uo-d";
export var solidNavy = "_uo-c";
export var solidOrange = "_uo-f";
export var solidPink = "_uo-e";
export var solidRed = "_uo-9";
export var solidYellow = "_uo-a";
export var success = "_uo-4";